import React from 'react';
import Button from 'components/Button';
import { Typography } from 'antd';
import { setup } from './setup';

const columns = [
  {
    title: 'Page Title',
    dataIndex: 'title',
    key: 'title',
    sorter: true
  },
  {
    title: 'Slug',
    dataIndex: 'slug',
    key: 'slug',
    render: (text, record) => <Typography.Text code>{text}</Typography.Text>
  },
  {
    title: 'Actions',
    key: 'actions',
    render: (text, record) => (
      <Button type="primary" ghost size="small" to={`/${setup.model}/edit/${record.id}`}>
        View
      </Button>
    )
  }
];

export default columns;
